import { useRecoilCallback } from 'recoil';
import { IActionFilter } from '../interfaces';
import { rideBookFilterAtom, rideBookFiltersAtom } from '../TripsOverviewState';

interface IUseFilter {
  updateFilterItemsState: (data: IActionFilter[]) => void;
}

const useFilter = (): IUseFilter => {
  const updateFilterItemsState = useRecoilCallback(
    ({ set, snapshot }) =>
      async (data: IActionFilter[]) => {
        const ids: string[] = [];
        data.forEach((filterItem: IActionFilter) => {
          ids.push(String(filterItem.id));

          set(rideBookFilterAtom(String(filterItem.id)), () => filterItem);
        });
        const rideBookFilters = await snapshot.getPromise(rideBookFiltersAtom);
        if (data[0] && !rideBookFilters.includes(String(data[0].id))) {
          const newRideFilterIds: string[] = [...rideBookFilters, ...ids];
          set(rideBookFiltersAtom, newRideFilterIds);
        }
      }
  );

  return {
    updateFilterItemsState,
  };
};

export default useFilter;
